module.exports = __webpack_public_path__ + "epilace_1_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/epilace_1_after_tn.jpg
// module id = 1411
// module chunks = 0